import React from 'react';
import { Route } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

interface AppRouteProps {
  exact?: boolean;
  path: string;
}

export const ScreenSwapRoute: React.FC<AppRouteProps> = ({ exact, path, children }) => {
  return (
    <Route exact={exact} path={path}>
      {({ match }) => (
        <CSSTransition
          in={!!match}
          timeout={300}
          classNames="screen-swap-container"
          unmountOnExit={true}
        >
          <div className="screen-swap-container">{children}</div>
        </CSSTransition>
      )}
    </Route>
  );
};
